import md from '@/routes/middlewares';

import SiteDocuments from '@/views/sites/document/SiteDocuments.vue';
import SiteDocumentPage from '@/views/sites/document/SiteDocumentPage.vue';
import SiteDocument from '@/views/sites/document/SiteDocument.vue';

const document = [
    {
        path: 'documents',
        name: 'siteDocuments',
        component: SiteDocuments,
    },
    {
        path: 'documents/:documentId',
        component: SiteDocumentPage,
        redirect: { name: 'siteDocument' },
        meta: {
            middlewares: [
                md.getSiteDocument,
            ],
        },
        children: [
            {
                path: 'info',
                name: 'siteDocument',
                component: SiteDocument,
            },
        ],
    },
];

export default document;
